
export const ar = {
  // Navigation
  home: "الرئيسية",
  calendar: "التقويم",
  lists: "القوائم",
  profile: "الملف الشخصي",
  messages: "المراسلة",
  gallery: "المعرض",
  
  // App Name
  appName: "mohammed family",
  
  // Home Page
  welcomeFamily: "مرحباً بعائلة محمد",
  familyCalendar: "التقويم المشترك",
  sharedLists: "القوائم المشتركة",
  messaging: "المراسلة",
  mediaLibrary: "مكتبة الصور",
  
  // Calendar
  addEvent: "إضافة حدث",
  upcomingEvents: "الأحداث القادمة",
  today: "اليوم",
  
  // Lists
  shoppingList: "قائمة التسوق",
  houseTasks: "المهام المنزلية",
  addItem: "إضافة عنصر",
  completed: "مكتمل",
  
  // Profile
  editProfile: "تعديل الملف الشخصي",
  notifications: "الإشعارات",
  logout: "تسجيل الخروج",
  
  // Messages
  sendMessage: "إرسال رسالة",
  typeMessage: "اكتب رسالة...",
  familyChat: "محادثة العائلة",
  
  // Gallery
  addPhoto: "إضافة صورة",
  familyPhotos: "صور العائلة",
  selectPhoto: "اختر صورة",
  
  // Common
  add: "إضافة",
  edit: "تعديل",
  delete: "حذف",
  save: "حفظ",
  cancel: "إلغاء",
  done: "تم"
};

export default ar;
